export default __webpack_public_path__ + "static/media/EM0240.34I-22006_-15369_0.f57cd873.jpg";